import { Injectable } from '@angular/core';
import { IconSettingsService } from '@progress/kendo-angular-icons';

@Injectable()
export class KendoIconsService extends IconSettingsService {
  private iconDictionary: { [key: string]: string } = {
    'caret-alt-up': 'app-icon icon icon-chevron-up k-button-icon k-icon',
    'caret-alt-down': 'app-icon icon icon-chevron-down k-button-icon k-icon',
    calendar: 'app-icon icon icon-calendar icon-xl k-button-icon k-icon',
  };

  public override getCustomFontIconClass(iconName: string): string {
    return this.iconDictionary[iconName] || super.getCustomFontIconClass(iconName);
  }
}
